import Cookies from "../../libs/js-cookie/src/js.cookie";

class PromoBanner {
    constructor() {

        this.el = document.querySelector('.promo-footer');
        //store other components element selectors here to be notified when promo is opened
        //fs-player is for pinning video but you can add more
        this.otherComponentElements = ['.fs-player'];

        (this.el) && this.setupPromo();

    }

    setupPromo() {

            var promo_id;
            var promo_cookie;
            var dismiss_close;
            var promo_self_hide;
            var promo_timeout;

            promo_id = this.el.getAttribute('id');
            promo_self_hide = this.el.classList.contains('self-hide');

            if (promo_self_hide) {
                promo_timeout = this.el.getAttribute('timeout');
                /**
                 * when using setTimeout function, please use arrow function; otherwise this will bind to the window object
                 */
                setTimeout( () => {
                    this.hidePromo(this.el);
                }, promo_timeout * 1000);
            }

            promo_cookie = Cookies.get('fsc-' + promo_id);

            if (undefined === promo_cookie) {
                if (window.innerWidth >= 768 && this.el.classList.contains('hide-promo-mobile') || !this.el.classList.contains('hide-promo-mobile')) {
                    this.showPromo(this.el);
                }
            } else {
                this.hidePromo(this.el);
            } // if/else

            this.setCloseButton(this.el,promo_id);

        }
        
        showPromo(el){
            el.classList.remove('hide-promo');
            el.classList.add('show-promo');
            el.setAttribute('aria-hidden', 'false');
            //for video pinning - refer to Pinner.js
            this.notifyOtherElements(true);
        }

        hidePromo(el){
            el.classList.remove('show-promo');
            el.classList.add('hide-promo');
            el.setAttribute('aria-hidden', 'true');
            
            this.notifyOtherElements(false);
        }

        //add classname to other elements
        notifyOtherElements(isPromoShowing){

            let activeName = "promo-active";

            if(this.otherComponentElements.length > 0){
                this.otherComponentElements.map((selector) => {
                    let fsPlayerEl = document.querySelector(selector);
                    if(fsPlayerEl){
                        (isPromoShowing) ? fsPlayerEl.classList.add(activeName) : fsPlayerEl.classList.remove(activeName);
                    }
                });
            }
            
        }


        setCloseButton(el,promo_id){
            let dismiss_close = document.getElementById('close-' + promo_id);
            dismiss_close.addEventListener('click', () => {
                this.onClosePromoClick(el,promo_id);
            });
        }

        onClosePromoClick(el,promo_id){

            if (el.classList.contains('show-promo')) {
                this.hidePromo(el);
            }

            promo_id = el.getAttribute('id');
            Cookies.set('fsc-' + promo_id, 'dismissed', { expires: 7 });

        }

} // PromoBanner
export default new PromoBanner();


// WEBPACK FOOTER //
// ./assets/components/promo/promo.js